import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService, LoadingState } from '../../../services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LoadingOverlayComponent {
  private loading = inject(LoadingService);
  state$: Observable<LoadingState> = this.loading.state$;
}
